import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgDownArrowGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 9,
    fill: "none",
    viewBox: "0 0 15 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#797979",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M2 2l5.5 5.5L13 2"
  })));
}

export { SvgDownArrowGrey as ReactComponent };
//# sourceMappingURL=DownArrowGrey.svg.js.map
